import ProfileWhitelistList from '@/features/profileWhitelist/ProfileWhitelistList.vue';
import ProfileWhitelistCreateByPhone from '@/features/profileWhitelist/ProfileWhitelistCreateByPhone.vue';
import ProfileWhitelistCreateByCountryCode from '@/features/profileWhitelist/ProfileWhitelistCreateByCountryCode.vue';
import ProfileNonWhitelistList from '@/features/profileWhitelist/ProfileNonWhitelistList.vue';
import ProfileNonWhitelistedProfilesDetails from '@/features/profileWhitelist/ProfileNonWhitelistedProfilesDetails.vue';
import { ProfileWhitelistRels } from '@/features/profileWhitelist/rels';

export const ProfileWhitelistRoutes = [
    {
        path: '/profile-whitelist',
        name: ProfileWhitelistRels.GetProfileWhitelists,
        component: ProfileWhitelistList
    },
    {
        path: '/profile-whitelist/create-by-phone',
        name: ProfileWhitelistRels.CreateProfileWhitelistByPhone,
        component: ProfileWhitelistCreateByPhone
    },
    {
        path: '/profile-whitelist/create-by-country-code',
        name: ProfileWhitelistRels.CreateProfileWhitelistByCountryCode,
        component: ProfileWhitelistCreateByCountryCode
    },
    {
        path: '/profile-whitelist/nonwhitelisted-stats',
        name: ProfileWhitelistRels.GetNonWhitelistedProfileStats,
        component: ProfileNonWhitelistList
    },
    {
        path: '/profile-whitelist/nonwhitelisted-profiles/:phoneCountryCode',
        name: ProfileWhitelistRels.FindNonWhitelistedProfiles,
        component: ProfileNonWhitelistedProfilesDetails
    }
];
